module.exports = __webpack_public_path__ + "assets/ban.22941150.svg";